export const connectorDefinitions = [
  {
    id: 'postgres',
    name: 'PostgreSQL',
    category: 'database',
    icon: 'Database',
    description: 'Connect to PostgreSQL databases',
    supported: true,
    fields: [
      { name: 'host', label: 'Host', type: 'text', required: true, placeholder: 'localhost' },
      { name: 'port', label: 'Port', type: 'number', required: true, placeholder: '5432' },
      { name: 'database', label: 'Database', type: 'text', required: true, placeholder: 'mydb' },
      { name: 'username', label: 'Username', type: 'text', required: true, placeholder: 'postgres' },
      { name: 'password', label: 'Password', type: 'password', required: true },
      { name: 'ssl_mode', label: 'SSL Mode', type: 'select', required: false, options: [
        { label: 'Disable', value: 'disable' },
        { label: 'Require', value: 'require' },
        { label: 'Verify CA', value: 'verify-ca' },
        { label: 'Verify Full', value: 'verify-full' },
      ]},
      { name: 'schema', label: 'Default Schema', type: 'text', required: false, placeholder: 'public' },
    ],
  },
  {
    id: 'sqlserver',
    name: 'SQL Server',
    category: 'database',
    icon: 'Database',
    description: 'Connect to Microsoft SQL Server',
    supported: true,
    fields: [
      { name: 'host', label: 'Host', type: 'text', required: true, placeholder: 'localhost' },
      { name: 'port', label: 'Port', type: 'number', required: true, placeholder: '1433' },
      { name: 'database', label: 'Database', type: 'text', required: true, placeholder: 'master' },
      { name: 'username', label: 'Username', type: 'text', required: true, placeholder: 'sa' },
      { name: 'password', label: 'Password', type: 'password', required: true },
      { name: 'encrypt', label: 'Encrypt Connection', type: 'checkbox', required: false },
      { name: 'trust_server_certificate', label: 'Trust Server Certificate', type: 'checkbox', required: false },
    ],
  },
  {
    id: 'databricks',
    name: 'Databricks',
    category: 'database',
    icon: 'Database',
    description: 'Connect to Databricks SQL warehouses',
    supported: true,
    fields: [
      { name: 'server_hostname', label: 'Server Hostname', type: 'text', required: true, placeholder: 'dbc-1234-5678.cloud.databricks.com' },
      { name: 'http_path', label: 'HTTP Path', type: 'text', required: true, placeholder: '/sql/1.0/warehouses/abc123' },
      { name: 'access_token', label: 'Access Token', type: 'password', required: true, helpText: 'Personal access token from Databricks' },
      { name: 'catalog', label: 'Catalog', type: 'text', required: false, placeholder: 'main' },
      { name: 'schema', label: 'Schema', type: 'text', required: false, placeholder: 'default' },
    ],
  },
  {
    id: 'salesforce',
    name: 'Salesforce',
    category: 'saas',
    icon: 'Cloud',
    description: 'Connect to Salesforce CRM',
    supported: true,
    fields: [
      { name: 'username', label: 'Username', type: 'text', required: true, placeholder: 'user@company.com' },
      { name: 'password', label: 'Password', type: 'password', required: true },
      { name: 'security_token', label: 'Security Token', type: 'password', required: true, helpText: 'Found in Salesforce setup under Reset Security Token' },
      { name: 'domain', label: 'Domain', type: 'select', required: true, options: [
        { label: 'Production (login.salesforce.com)', value: 'login' },
        { label: 'Sandbox (test.salesforce.com)', value: 'test' },
      ]},
      { name: 'api_version', label: 'API Version', type: 'text', required: false, placeholder: '58.0' },
    ],
  },
  {
    id: 'hubspot',
    name: 'HubSpot',
    category: 'saas',
    icon: 'Cloud',
    description: 'Connect to HubSpot CRM',
    supported: true,
    fields: [
      { name: 'access_token', label: 'Private App Access Token', type: 'password', required: true, helpText: 'Create a private app in HubSpot settings' },
      { name: 'portal_id', label: 'Portal ID', type: 'text', required: false, placeholder: '12345678', helpText: 'Optional: Your HubSpot account ID' },
    ],
  },
  {
    id: 'jira',
    name: 'Jira',
    category: 'saas',
    icon: 'Cloud',
    description: 'Connect to Jira project management',
    supported: true,
    fields: [
      { name: 'url', label: 'Jira URL', type: 'text', required: true, placeholder: 'https://yourcompany.atlassian.net' },
      { name: 'username', label: 'Email', type: 'text', required: true, placeholder: 'user@company.com' },
      { name: 'api_token', label: 'API Token', type: 'password', required: true, helpText: 'Generate from https://id.atlassian.com/manage/api-tokens' },
      { name: 'project_keys', label: 'Project Keys', type: 'text', required: false, placeholder: 'PROJ1,PROJ2', helpText: 'Comma-separated list (optional)' },
    ],
  },
  {
    id: 'gsheets',
    name: 'Google Sheets',
    category: 'file',
    icon: 'FileText',
    description: 'Connect to Google Sheets',
    supported: true,
    fields: [
      { name: 'spreadsheet_id', label: 'Spreadsheet ID', type: 'text', required: true, placeholder: '1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgvE2upms', helpText: 'Found in the spreadsheet URL' },
      { name: 'credentials_json', label: 'Service Account JSON', type: 'textarea', required: true, helpText: 'Paste the entire JSON credentials file content' },
      { name: 'sheet_name', label: 'Sheet Name', type: 'text', required: false, placeholder: 'Sheet1' },
    ],
  },
  {
    id: 'file_upload',
    name: 'File Upload',
    category: 'file',
    icon: 'Upload',
    description: 'Upload files from your local machine for processing and analysis',
    supported: true,
    fields: [
      { name: 'name', label: 'Upload Area Name', type: 'text', required: true, placeholder: 'My File Uploads', helpText: 'A descriptive name for this file upload area' },
    ],
  },
  // Coming soon
  { id: 'kafka', name: 'Apache Kafka', category: 'streaming', icon: 'Radio', description: 'Connect to Kafka message broker', supported: false, fields: [] },
  { id: 'mysql', name: 'MySQL', category: 'database', icon: 'Database', description: 'Connect to MySQL databases', supported: false, fields: [] },
  { id: 'mongodb', name: 'MongoDB', category: 'database', icon: 'Database', description: 'Connect to MongoDB', supported: false, fields: [] },
  { id: 'servicenow', name: 'ServiceNow', category: 'saas', icon: 'Cloud', description: 'Connect to ServiceNow', supported: false, fields: [] },
  { id: 's3', name: 'Amazon S3', category: 'file', icon: 'FileText', description: 'Connect to Amazon S3 buckets', supported: false, fields: [] },
  { id: 'gcs', name: 'Google Cloud Storage', category: 'file', icon: 'FileText', description: 'Connect to Google Cloud Storage', supported: false, fields: [] },
  { id: 'azure_blob', name: 'Azure Blob Storage', category: 'file', icon: 'FileText', description: 'Connect to Azure Blob Storage', supported: false, fields: [] },
  { id: 'snowflake', name: 'Snowflake', category: 'database', icon: 'Database', description: 'Connect to Snowflake data warehouse', supported: false, fields: [] },
  { id: 'bigquery', name: 'Google BigQuery', category: 'database', icon: 'Database', description: 'Connect to Google BigQuery', supported: false, fields: [] },
  { id: 'redshift', name: 'Amazon Redshift', category: 'database', icon: 'Database', description: 'Connect to Amazon Redshift', supported: false, fields: [] },
  { id: 'oracle', name: 'Oracle Database', category: 'database', icon: 'Database', description: 'Connect to Oracle databases', supported: false, fields: [] },
  { id: 'zendesk', name: 'Zendesk', category: 'saas', icon: 'Cloud', description: 'Connect to Zendesk support platform', supported: false, fields: [] },
  { id: 'stripe', name: 'Stripe', category: 'saas', icon: 'Cloud', description: 'Connect to Stripe payment platform', supported: false, fields: [] },
  { id: 'shopify', name: 'Shopify', category: 'saas', icon: 'Cloud', description: 'Connect to Shopify e-commerce platform', supported: false, fields: [] },
  { id: 'slack', name: 'Slack', category: 'saas', icon: 'Cloud', description: 'Connect to Slack workspace', supported: false, fields: [] },
  { id: 'github', name: 'GitHub', category: 'saas', icon: 'Cloud', description: 'Connect to GitHub repositories', supported: false, fields: [] },
];

export function getConnectorDefinition(connectorId) {
  return connectorDefinitions.find(c => c.id === connectorId.toLowerCase());
}
